import { Toast } from 'flowbite-react';

import { type ToastData, ToastNotificationType } from './toastNotifications.context';

type Props = {
    toasts: ToastData[];
    setToasts: React.Dispatch<React.SetStateAction<ToastData[]>>;
}

const ToastNotificationsContainer = ({ toasts, setToasts }: Props) => {
    const getToastClassNames = (type: ToastNotificationType) => {
        if (type === ToastNotificationType.ERROR) {
            return 'border-l-4 border-red-400';
        } else if (type === ToastNotificationType.SUCCESS) {
            return 'border-l-4 border-green-400';
        }
        return '';
    };

    return (
        <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
            {toasts.map(({ id, props }) => (
                <Toast key={id} className={getToastClassNames(props.type)}>
                    <div className="mr-3 text-sm font-medium">{props.message}</div>
                    <Toast.Toggle onDismiss={() => setToasts(prev => prev.filter(t => t.id !== id))} />
                </Toast>
            ))}
        </div>
    );
};

export default ToastNotificationsContainer;
